export const UPDATE_PASSWORD_SUCCESS = 'createPassword/UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_ERROR = 'createPassword/UPDATE_PASSWORD_ERROR'
export const UPDATE_PASSWORD = 'createPassword/UPDATE_PASSWORD'

export const FORGOT_PASSWORD_SUCCESS = 'createPassword/FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'createPassword/FORGOT_PASSWORD_ERROR'
export const FORGOT_PASSWORD = 'createPassword/FORGOT_PASSWORD'

export const RESET = 'createPassword/RESET'
